var _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcTiktok(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 89,
    viewBox: "0 0 89 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 44.4286,
    cy: 44.4286,
    r: 44.4286,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_54_446)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5.85693,
    y: 4.85211,
    width: 78,
    height: 78,
    rx: 39,
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.2955 34.6404C62.9502 34.6404 61.618 34.3754 60.3751 33.8606C59.1322 33.3458 58.0029 32.5912 57.0516 31.6399C56.1003 30.6887 55.3457 29.5593 54.8308 28.3164C54.316 27.0735 54.051 25.7414 54.051 24.396H46.732V53.056C46.7306 54.3626 46.318 55.6357 45.5527 56.6948C44.7873 57.7539 43.7081 58.5452 42.4679 58.9566C41.2277 59.368 39.8894 59.3787 38.6428 58.9871C37.3962 58.5954 36.3045 57.8214 35.5224 56.7747C34.7403 55.7279 34.3074 54.4616 34.2852 53.1551C34.263 51.8486 34.6526 50.5683 35.3987 49.4956C36.1448 48.4228 37.2096 47.6122 38.4422 47.1784C39.6747 46.7447 41.0126 46.7098 42.266 47.0789V39.9643C39.6022 39.6051 36.8921 40.0671 34.4978 41.2887C32.1034 42.5102 30.1387 44.4332 28.866 46.8008C27.5933 49.1683 27.0732 51.8678 27.3751 54.5388C27.677 57.2097 28.7866 59.725 30.5556 61.7488C32.3247 63.7725 34.6691 65.2084 37.2757 65.8647C39.8823 66.521 42.6271 66.3664 45.1435 65.4217C47.66 64.4769 49.8283 62.787 51.3591 60.5774C52.8898 58.3679 53.71 55.7439 53.7101 53.056L53.9225 38.5692C56.9297 40.7768 60.5641 41.9646 64.2946 41.9591L64.2955 34.6404Z",
    fill: "url(#paint0_linear_54_446)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.3606 32.6466C59.6436 32.6466 57.038 31.5672 55.1168 29.646C53.1957 27.7248 52.1165 25.1191 52.1165 22.4022H44.7975V51.0621C44.7961 52.3688 44.3835 53.6418 43.6182 54.7009C42.8529 55.76 41.7736 56.5514 40.5334 56.9628C39.2932 57.3743 37.955 57.3849 36.7084 56.9933C35.4617 56.6017 34.37 55.8277 33.5879 54.781C32.8057 53.7342 32.3729 52.4679 32.3507 51.1614C32.3285 49.8549 32.718 48.5746 33.4641 47.5018C34.2102 46.4291 35.275 45.6184 36.5076 45.1847C37.7402 44.7509 39.078 44.7161 40.3315 45.0851V37.9704C37.6676 37.6112 34.9576 38.0732 32.5632 39.2948C30.1689 40.5164 28.2042 42.4393 26.9315 44.8069C25.6587 47.1744 25.1386 49.8739 25.4405 52.5449C25.7424 55.2158 26.852 57.7311 28.6211 59.7549C30.3901 61.7786 32.7345 63.2145 35.3411 63.8708C37.9477 64.5271 40.6925 64.3725 43.209 63.4278C45.7255 62.483 47.8938 60.7931 49.4245 58.5835C50.9552 56.374 51.7754 53.75 51.7756 51.0621L51.9891 36.5754C54.9963 38.783 58.6308 39.9708 62.3613 39.9652L62.3606 32.6466Z",
    fill: "url(#paint1_linear_54_446)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.3607 34.4572C59.8283 33.9699 57.5729 32.5456 56.0447 30.4684C54.1131 28.9567 52.7881 26.802 52.3108 24.396H46.7324V53.056C46.7323 54.4162 46.2871 55.739 45.4648 56.8225C44.6424 57.906 43.4882 58.6906 42.1781 59.0566C40.8681 59.4227 39.4743 59.35 38.2095 58.8497C36.9446 58.3494 35.8782 57.449 35.173 56.2858C33.919 55.4696 33.0006 54.2294 32.5855 52.7919C32.1704 51.3544 32.2865 49.8155 32.9124 48.4564C33.5383 47.0974 34.6323 46.009 35.9945 45.39C37.3567 44.771 38.8962 44.6628 40.3316 45.0852V39.8496C37.8695 39.8813 35.4654 40.6006 33.3905 41.9263C31.3155 43.2519 29.6525 45.1312 28.589 47.3519C27.5255 49.5726 27.104 52.0464 27.3719 54.494C27.6398 56.9417 28.5866 59.2657 30.1054 61.2037C32.0335 62.8126 34.3802 63.8384 36.8706 64.161C39.361 64.4837 41.8917 64.0897 44.1661 63.0253C46.4405 61.9609 48.3644 60.2701 49.7121 58.1513C51.0599 56.0325 51.7757 53.5733 51.7757 51.0622L51.9892 36.5755C54.9964 38.783 58.6309 39.9709 62.3614 39.9653L62.3607 34.4572Z",
    fill: "url(#paint2_linear_54_446)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_54_446",
    x1: 30.2248,
    y1: 61.4583,
    x2: 60.669,
    y2: 31.0139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B5053C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.233,
    stopColor: "#C90441"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.737,
    stopColor: "#F0014B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF004F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_54_446",
    x1: 27.8366,
    y1: 59.9175,
    x2: 59.9058,
    y2: 27.8485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B2C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.283,
    stopColor: "#00C8D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.741,
    stopColor: "#00E6E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F1EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_54_446",
    x1: 9.87009,
    y1: 79.8486,
    x2: 80.8553,
    y2: 8.8635,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDE3E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCF7F7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_54_446"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 78,
    height: 78,
    fill: "white",
    transform: "translate(5.85693 4.85211)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTiktok);
export default __webpack_public_path__ + "static/media/ic_tiktok.5bf8bea29b7e9c54e2b482fa9aeec2fc.svg";
export { ForwardRef as ReactComponent };